import React, { useState } from "react";
import { FiPlay, FiBookOpen, FiInfo, FiClock } from "react-icons/fi";
import FlashcardSession from "./FlashcardSession";
import styles from "../styles/home.module.css";

const FlashcardMessage = ({ flashcardData, onComplete }) => {
  const [isStarted, setIsStarted] = useState(false);

  const handleStartFlashcards = () => {
    setIsStarted(true);
  };

  const handleFlashcardComplete = (results) => {
    setIsStarted(false);
    if (onComplete) {
      onComplete(results);
    }
  };

  const handleFlashcardExit = () => {
    setIsStarted(false);
  };

  // Modal is rendered conditionally below

  return (
    <div className={styles.inlineLearningContainer}>
      <div className={styles.inlineLearningHeader}>
        <div className={styles.inlineHeaderLeft}>
          <FiBookOpen className={styles.flashcardIcon} />
          <div>
            <h3 className={styles.inlineTitle}>{flashcardData.title}</h3>
            {flashcardData.description && (
              <p className={styles.inlineSubtitle}>{flashcardData.description}</p>
            )}
          </div>
        </div>
        {!isStarted && (
          <button onClick={handleStartFlashcards} className={styles.primaryButton}>
            <FiPlay /> Start Studying
          </button>
        )}
      </div>

      {!isStarted && (
        <div className={styles.inlineMetaRow}>
          <span className={styles.metaPill}><FiInfo /> {flashcardData.cards.length} cards</span>
          <span className={styles.metaPill}><FiClock /> ~{Math.ceil(flashcardData.cards.length * 0.5)} min</span>
        </div>
      )}

      {!isStarted && flashcardData.cards?.length > 0 && (
        <div className={styles.previewChips}>
          {flashcardData.cards.slice(0, 3).map((card, index) => (
            <div key={index} className={styles.previewChip}>
              {card.question.length > 60 ? card.question.substring(0, 60) + "..." : card.question}
            </div>
          ))}
          {flashcardData.cards.length > 3 && (
            <div className={styles.previewMore}>+{flashcardData.cards.length - 3} more</div>
          )}
        </div>
      )}

      {isStarted && (
        <div className={styles.inlineLearningBody}>
          <FlashcardSession 
            flashcardData={flashcardData} 
            onComplete={handleFlashcardComplete} 
            onExit={handleFlashcardExit} 
          />
        </div>
      )}
    </div>
  );
};

export default FlashcardMessage;
